import { createPortal } from 'react-dom'

// Also, set a default value for wrapperId prop if none provided
type PortalProps = {
  children: React.ReactNode
  wrapperId?: string
}

const ReactPortal: React.FC<PortalProps> = ({ children, wrapperId = 'portal' }) => {
  let element = document.getElementById(wrapperId)

  const createWrapperAndAppendToBody = (wrapperId: string) => {
    const wrapperElement = document.createElement('div')
    wrapperElement.setAttribute('id', wrapperId)
    document.body.appendChild(wrapperElement)
    return wrapperElement
  }

  if (!element) {
    element = createWrapperAndAppendToBody(wrapperId)
  }

  return createPortal(children, element)
}

export default ReactPortal
